// Shared 3D clay icon set. Single source of truth so every surface
// (homepage CTA tiles, Contact help-hub tiles, future placeholders)
// reuses the exact same clay artwork and stays visually consistent.
// New placeholder icons should be added here in the same clay style.
const IMG = 'https://static.prod-images.emergentagent.com/jobs/eaad4cf4-b013-4778-bbae-d982e539f07c/images';

export const clayIcon = {
  builders: `${IMG}/c53a92ee9f1b912a50672e6181a0ec70810285c13ba6bfc5d549d22965fffc94.jpeg`,
  suppliers: `${IMG}/730b7401b44928111bd6063a4f4b0fe3caf16a88a3b2e7d3f8bea8e0eff65e72.jpeg`,
  trades: `${IMG}/b1877c70653d9205876a344eca3f9b65da6257d19738734a53ab2334937bd265.jpeg`,
  pros: `${IMG}/6574a97a18715f9381c8031c195aea57c45b8691f4f39aae7cef70a554e855e7.jpeg`,
  partner: `${IMG}/b98ec4ca4cc15cec34ad7404fb6a3fbe8b017f5da9d1f2bda22b1f27e59a8460.jpeg`,
  community: `${IMG}/84c224b75867fe4730dafab9dbe98051f03e9a65bf4b06624a6e52e4293f8aa6.jpeg`,
  app: `${IMG}/0bcfb015a45b9f4d64d6683806449f4efab24de8690c0b816d1eb1435c16d715.jpeg`,
  oneOnOne: `${IMG}/8863b1b6067c9096603f6287aa835af445d4a6204958a12d9add38033cf904b1.jpeg`,
  howItWorks: `${IMG}/3d0ab26525055a3d962efd5e9116613bd8b1d17e43df08316d357329a483d284.jpeg`,
};

export default clayIcon;
